// Mock data for SMFS Maps (Avenza-style clone)

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_cartography-app-5/artifacts/hex0jv7u_FullLogo_NoBuffer.jpg";

export const BRAND = {
  name: "SMFS Maps",
  tagline: "Laying Out Access",
  description:
    "Professional offline mapping for forestry, transmission line layout, environmental survey and field operations."
};

// 6 mock georeferenced PDF maps the user has "uploaded/downloaded"
export const MAPS = [
  {
    id: "map-001",
    title: "North Ridge Forestry Block 14",
    category: "Forestry",
    description:
      "Timber cruise grid and harvest block boundaries for the North Ridge cut block.",
    thumbnail:
      "https://images.unsplash.com/photo-1448375240586-882707db888b?w=800&q=80&auto=format&fit=crop",
    bounds: [[49.246, -123.116], [49.302, -123.020]],
    center: [49.274, -123.068],
    zoom: 13,
    size: "24.6 MB",
    pages: 4,
    updated: "2025-06-12",
    downloaded: true,
    source: "Field Office",
    layers: 3,
    featuresCount: 142
  },
  {
    id: "map-002",
    title: "500kV Transmission Corridor — Segment B",
    category: "Transmission Line",
    description:
      "Tower placement, ROW boundaries and access roads for segment B of the cross-valley HV line.",
    thumbnail:
      "https://images.unsplash.com/photo-1473773508845-188df298d2d1?w=800&q=80&auto=format&fit=crop",
    bounds: [[50.05, -114.20], [50.18, -113.85]],
    center: [50.115, -114.025],
    zoom: 11,
    size: "58.1 MB",
    pages: 12,
    updated: "2025-05-28",
    downloaded: true,
    source: "Engineering",
    layers: 5,
    featuresCount: 387
  },
  {
    id: "map-003",
    title: "Cedar Creek Environmental Assessment",
    category: "Environmental",
    description:
      "Wetlands, riparian buffers and species-at-risk observation points across the Cedar Creek watershed.",
    thumbnail:
      "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800&q=80&auto=format&fit=crop",
    bounds: [[48.40, -123.45], [48.51, -123.30]],
    center: [48.455, -123.375],
    zoom: 12,
    size: "33.9 MB",
    pages: 6,
    updated: "2025-07-02",
    downloaded: false,
    source: "Avenza Store",
    layers: 4,
    featuresCount: 218
  },
  {
    id: "map-004",
    title: "Mt. Brendan Pipeline ROW",
    category: "Transmission Line",
    description:
      "Right-of-way clearing limits and tie-in stations along the Mt. Brendan natural gas pipeline.",
    thumbnail:
      "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=800&q=80&auto=format&fit=crop",
    bounds: [[51.04, -115.61], [51.18, -115.30]],
    center: [51.11, -115.455],
    zoom: 11,
    size: "41.3 MB",
    pages: 8,
    updated: "2025-04-19",
    downloaded: true,
    source: "Field Office",
    layers: 4,
    featuresCount: 274
  },
  {
    id: "map-005",
    title: "Silver Lake Reforestation Survey",
    category: "Forestry",
    description:
      "Stocking density plots and species composition for the 2024 Silver Lake replant.",
    thumbnail:
      "https://images.unsplash.com/photo-1542273917363-3b1817f69a2d?w=800&q=80&auto=format&fit=crop",
    bounds: [[53.50, -119.20], [53.62, -118.95]],
    center: [53.56, -119.075],
    zoom: 12,
    size: "19.2 MB",
    pages: 3,
    updated: "2025-07-10",
    downloaded: true,
    source: "Internal Upload",
    layers: 2,
    featuresCount: 96
  },
  {
    id: "map-006",
    title: "Coastal Erosion Monitoring — Year 3",
    category: "Environmental",
    description:
      "Bluff retreat transects and sediment sample stations along the Pacific coastline.",
    thumbnail:
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&q=80&auto=format&fit=crop",
    bounds: [[49.18, -125.95], [49.30, -125.70]],
    center: [49.24, -125.825],
    zoom: 12,
    size: "28.7 MB",
    pages: 5,
    updated: "2025-06-30",
    downloaded: false,
    source: "Avenza Store",
    layers: 3,
    featuresCount: 159
  },
  {
    id: "map-007",
    title: "Ranger District Access Roads",
    category: "Other",
    description:
      "Maintained and seasonal forest service roads with gate locations and condition ratings.",
    thumbnail:
      "https://images.unsplash.com/photo-1502082553048-f009c37129b9?w=800&q=80&auto=format&fit=crop",
    bounds: [[44.20, -110.70], [44.45, -110.30]],
    center: [44.325, -110.50],
    zoom: 11,
    size: "36.5 MB",
    pages: 7,
    updated: "2025-05-15",
    downloaded: true,
    source: "Field Office",
    layers: 3,
    featuresCount: 312
  },
  {
    id: "map-008",
    title: "Riparian Restoration — Elk Valley",
    category: "Environmental",
    description:
      "Planting zones, water quality monitoring stations and pre-restoration baselines.",
    thumbnail:
      "https://images.unsplash.com/photo-1431794062232-2a99a5431c6c?w=800&q=80&auto=format&fit=crop",
    bounds: [[49.50, -114.95], [49.62, -114.70]],
    center: [49.56, -114.825],
    zoom: 12,
    size: "22.1 MB",
    pages: 4,
    updated: "2025-07-05",
    downloaded: true,
    source: "Internal Upload",
    layers: 3,
    featuresCount: 87
  }
];

export const CATEGORIES = ["All", "Forestry", "Transmission Line", "Environmental", "Other"];

export const FEATURES = [
  {
    id: "f1",
    icon: "Ruler",
    title: "Measuring Tool",
    description:
      "Measure distances, areas and perimeters directly on your georeferenced PDF maps with sub-metre accuracy."
  },
  {
    id: "f2",
    icon: "Pencil",
    title: "Create Shapefiles",
    description:
      "Draw polygon features in the field and export industry-standard ESRI Shapefiles ready for GIS workflows."
  },
  {
    id: "f3",
    icon: "Route",
    title: "GPX Polylines",
    description:
      "Trace roads, trails or transmission lines and export to GPX for sharing or post-processing."
  },
  {
    id: "f4",
    icon: "LocateFixed",
    title: "Show My Location",
    description:
      "Real-time GPS positioning overlaid on your PDF maps — works fully offline once tiles are cached."
  },
  {
    id: "f5",
    icon: "FileText",
    title: "Georeferenced PDFs",
    description:
      "Import any GeoPDF or GeoTIFF and SMFS Maps will automatically align it to real-world coordinates."
  },
  {
    id: "f6",
    icon: "Cloud",
    title: "Cloud Sync",
    description:
      "Sync maps and field data between desktop, tablet and the field crew's mobile devices."
  }
];

export const PRICING = [
  {
    id: "p1",
    name: "Field",
    price: 0,
    period: "forever",
    blurb: "For individual crew members in the field.",
    features: [
      "Up to 3 imported maps",
      "GPS location & tracking",
      "Basic measure tool",
      "GPX export",
      "Community support"
    ],
    cta: "Get Started",
    highlight: false
  },
  {
    id: "p2",
    name: "Pro",
    price: 39,
    period: "per user / month",
    blurb: "For working professionals & small crews.",
    features: [
      "Unlimited maps",
      "Shapefile + GPX export",
      "Custom map layers",
      "Photo geotagging",
      "Priority email support"
    ],
    cta: "Start 14-day Trial",
    highlight: true
  },
  {
    id: "p3",
    name: "Enterprise",
    price: null,
    period: "contact us",
    blurb: "For organizations managing many crews.",
    features: [
      "Everything in Pro",
      "SSO & role-based access",
      "Central admin dashboard",
      "Custom integrations",
      "Dedicated success manager"
    ],
    cta: "Contact Sales",
    highlight: false
  }
];

export const STATS = [
  { id: "s1", value: "35K+", label: "Field users worldwide" },
  { id: "s2", value: "180K+", label: "Maps shipped" },
  { id: "s3", value: "99.9%", label: "Offline reliability" },
  { id: "s4", value: "2008", label: "Trusted since" }
];

export const TESTIMONIALS = [
  {
    id: "t1",
    name: "Dana Mercer",
    role: "Forestry Technician, Pacific Timber",
    quote:
      "SMFS Maps has replaced our paper cruise sheets entirely. The GPS overlay on georeferenced PDFs is a game-changer in the bush."
  },
  {
    id: "t2",
    name: "Luis Carrillo",
    role: "Lineman Supervisor, GridWest Energy",
    quote:
      "Tower-by-tower verification used to take days. Now we tap a pin, capture the photo, and the shapefile is back at the office before lunch."
  },
  {
    id: "t3",
    name: "Priya Anand",
    role: "Environmental Consultant",
    quote:
      "Drawing buffer polygons and exporting them as shapefiles directly to my desktop GIS — exactly the workflow I needed."
  }
];
